import { FC } from 'react';
import { LibraryTabs, HubSwitch, Toolbar, Title } from '@bpm-web-app/components';
import { FeaturedAll } from '@bpm-web-app/components/pages';

const AllFeaturedPage: FC<{ title: string }> = ({ title }: { title: string }) => (
    <>
        <Title platform="download" title={title} />
        <Toolbar stickToHeader>
            <LibraryTabs />
            <HubSwitch />
        </Toolbar>
        <FeaturedAll />
    </>
);

export default AllFeaturedPage;

export async function getStaticProps() {
    return {
        props: {
            title: 'Featured'
        }
    };
}
